const CenterActionTypes = {
	/** ***************** ADD CENTER DETAILS START *********************** */
	ADD_CENTER_DETAILS_START: 'add_center_details_start',
	ADD_CENTER_DETAILS_SUCCESS: 'add_center_details_success',
	ADD_CENTER_DETAILS_FAILURE: 'add_center_details_failure',
	ADD_CENTER_DETAILS_RESPONSE_RESET: 'add_center_details_response_reset',
	ADD_CENTER_DETAILS_RESPONSE_CHANGED: 'add_center_details_response_changed',
	/** ***************** ADD CENTER DETAILS END *********************** */

	/** ***************** UPDATE CENTER DETAILS START *********************** */
	UPDATE_CENTER_DETAILS_START: 'update_center_details_start',
	UPDATE_CENTER_DETAILS_SUCCESS: 'update_center_details_success',
	UPDATE_CENTER_DETAILS_FAILURE: 'update_center_details_failure',
	UPDATE_CENTER_DETAILS_RESPONSE_RESET: 'update_center_details_response_reset',
	UPDATE_CENTER_DETAILS_RESPONSE_CHANGED: 'update_center_details_response_changed',
	/** ***************** UPDATE CENTER DETAILS END *********************** */

	/** ***************** GET CENTER DETAILS START *********************** */
	GET_CENTER_LIST_START: 'get_center_list_start',
	GET_CENTER_LIST_SUCCESS: 'get_center_list_success',
	GET_CENTER_LIST_FAILURE: 'get_center_list_failure',
	GET_CENTER_LIST_RESPONSE_RESET: 'get_center_list_response_reset',
	GET_CENTER_LIST_RESPONSE_CHANGED: 'get_center_list_response_changed',
	/** ***************** GET CENTER DETAILS END *********************** */

	/** ***************** FETCH CENTER DETAILS START *********************** */
	FETCH_CENTER_DETAILS_START: 'fetch_center_details_start',
	FETCH_CENTER_DETAILS_SUCCESS: 'fetch_center_details_success',
	FETCH_CENTER_DETAILS_FAILURE: 'fetch_center_details_failure',
	FETCH_CENTER_DETAILS_RESPONSE_RESET: 'fetch_center_details_response_reset',
	FETCH_CENTER_DETAILS_RESPONSE_CHANGED: 'fetch_center_details_response_changed',
	/** ***************** FETCH CENTER DETAILS END *********************** */

	/** ***************** DELETE CENTER DETAILS START *********************** */
	DELETE_CENTER_DETAILS_START: 'delete_center_details_start',
	DELETE_CENTER_DETAILS_SUCCESS: 'delete_center_details_success',
	DELETE_CENTER_DETAILS_FAILURE: 'delete_center_details_failure',
	DELETE_CENTER_DETAILS_RESPONSE_RESET: 'delete_center_details_response_reset',
	DELETE_CENTER_DETAILS_RESPONSE_CHANGED: 'delete_center_details_response_changed',
	/** ***************** DELETE CENTER DETAILS END *********************** */
};
export default CenterActionTypes;
